import { ErrorHandler, Injectable } from '@angular/core';
import { LoggerService } from './logger.service';


@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandlerService implements ErrorHandler {

  constructor(
    private readonly loggerService: LoggerService,
  ) { }

  handleError(error, message?): void {
    this.loggerService.error('GlobalErrorHandlerService catch error', error);
  }
}
